// The page scrolls on <html>, and globals.scss keeps `overflow-y: scroll` so the scrollbar gutter is
// always reserved. Modals freeze background scrolling, so the bar has to go too - left in place it
// reads as usable when it is not.
let lockCount = 0
let isApplied = false
let releaseHandle: number | undefined
let previousOverflow = ''
let previousPaddingRight = ''

function apply(): void {
  const html = document.documentElement
  // Measure before hiding: innerWidth includes the gutter, clientWidth does not.
  const gutter = window.innerWidth - html.clientWidth
  // Save only the two properties we touch. <html> also carries the top banner height variable set by
  // Framework and the overscroll-behavior set by NSidebar, and those have to survive the lock.
  previousOverflow = html.style.getPropertyValue('overflow')
  previousPaddingRight = html.style.getPropertyValue('padding-right')
  html.style.setProperty('overflow', 'hidden')
  if (gutter > 0) {
    // Replace the reclaimed scrollbar width so the page behind the backdrop does not jump sideways.
    html.style.setProperty('padding-right', `${gutter}px`)
  }
  isApplied = true
}

function restoreProperty(property: string, value: string): void {
  const html = document.documentElement
  if (value) {
    html.style.setProperty(property, value)
  } else {
    html.style.removeProperty(property)
  }
}

function release(): void {
  // Restore whatever was there before rather than clearing, so this composes with GlobalOverlay,
  // which sets `overflow` on <html> itself for the full-screen Setup/Framework overlays.
  restoreProperty('overflow', previousOverflow)
  restoreProperty('padding-right', previousPaddingRight)
  isApplied = false
}

export function lockPageScroll(): void {
  if (releaseHandle !== undefined) {
    // A modal is handing off to the next one - keep the lock rather than dropping it in between.
    window.clearTimeout(releaseHandle)
    releaseHandle = undefined
  }
  lockCount += 1
  if (!isApplied) {
    apply()
  }
}

export function unlockPageScroll(): void {
  if (lockCount === 0) {
    return
  }
  lockCount -= 1
  if (lockCount > 0 || !isApplied || releaseHandle !== undefined) {
    return
  }
  // Deferred by a task: NModalBackground keeps the outgoing backdrop alive for 300ms while the next
  // one mounts, and an immediate release would flicker the gutter back and forth. A timeout rather
  // than requestAnimationFrame, which is paused entirely while the tab is hidden.
  releaseHandle = window.setTimeout(() => {
    releaseHandle = undefined
    if (lockCount === 0) {
      release()
    }
  }, 0)
}
